import * as React from 'react';

import Next from './assets/Next.png';
import NGL from './assets/NGL.png';
import OverseasFreight from './assets/OverseasFreight.png';
import Pacifica from './assets/Pacifica.png';
import PDS from './assets/PDS.png';
import XPO from './assets/XPO.png';

interface BrandDescriptor {
  image: string;
  alt: string;
}

const brands: BrandDescriptor[] = [
  { image: XPO, alt: 'XPO Logistics' },
  { image: OverseasFreight, alt: 'Overseas Freight' },
  { image: Pacifica, alt: 'Paficia Logistics Group LLC' },
  { image: NGL, alt: 'NGL Transportation' },
  { image: Next, alt: 'Next' },
  { image: PDS, alt: 'Pacific Drayage Services' },
];

export const Brand: React.FC<BrandDescriptor> = (props) => {
  return (
    <div className="w-32 h-8 overflow-hidden shrink-0">
      <img src={props.image} alt={props.alt} />
    </div>
  );
};

export const Brands: React.FC = () => {
  return (
    <div className="grid grid-cols-3 gap-4 inline-grid">
      {brands.map((b) => (
        <Brand key={b.image} {...b} />
      ))}
    </div>
  );
};
